import { Domains } from '../../services/Domains';

export const RESERVE_DOMAIN = 'RESERVE_DOMAIN';
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION';
export const SET_DOMAINS_FOR_USER = 'SET_DOMAINS_FOR_USER';

function setDomainsForUser(domains) {
    return {
        type: SET_DOMAINS_FOR_USER,
        domains
    };
}

export const reserveDomain = (domain) => {
    return {
        type: RESERVE_DOMAIN,
        domain
    }
}

export const cancelReservation = (domain) => {
    return {
        type: CANCEL_RESERVATION,
        domain
    }
}

export const fetchDomains = () => {
    return async (dispatch) => {
        try {
            const domains = await Domains.list();
            dispatch(setDomainsForUser(domains));
        } catch (error) {
            console.log(error);
        }
    }
}
